// extracted by mini-css-extract-plugin
export default {"v-med":"(max-width: 768px)","largeCardInfoSection":"preview_cards__largeCardInfoSection__geL2V"};